module.exports = __webpack_public_path__ + "img/500a.b884ba33.png";